import {
    ADDMERCHANTCHARGE_SUCCESS,
    ADDMERCHANTCHARGE_FAILED,
    RESET_ADDMERCHANTCHARGE,
    LOADING_ADDMERCHANTCHARGE,
    NETWORK_ERROR_ADDMERCHANTCHARGE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDMERCHANTCHARGE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDMERCHANTCHARGE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDMERCHANTCHARGE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADDMERCHANTCHARGE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDMERCHANTCHARGE:
            return (state = initialState);
        default:
            return state;
    }
};
